import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { I18nService } from '@personal-area/global/i18n';
import { LangToCountryCodePipe } from '@personal-area/global/country';
import { LanguagePickerModalComponent } from '../language-picker-modal/language-picker-modal.component';

@Component({
  selector: 'pac-footer-language-select',
  templateUrl: './footer-language-select.component.html',
  styleUrls: ['./footer-language-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, DatePipe, LangToCountryCodePipe],
})
export class FooterLanguageSelectComponent {
  public now = Date.now();

  constructor(
    private readonly _i18nService: I18nService,
    private _dialog: MatDialog,
  ) {
  }

  public onLanguageChangeClick(): void {
    this._dialog.open(LanguagePickerModalComponent, {
      panelClass: 'partner-grade-popup-container',
      width: 'auto',
      direction: this._i18nService.isRtl ? 'rtl' : 'ltr',
      data: {
        languages: this._i18nService.supportedLanguages,
        setLanguage: this._setLanguage,
      },
    });
  }

  public get currentLanguage(): string {
    return this._i18nService.language;
  }

  private _setLanguage = (language: string): void => {
    this._i18nService.language = language;
    this._dialog.closeAll();
  };
}
